import type { IError } from "@/shared/common/types";
import { EmptyOrErrorContent } from "@/shared/components";
import { Spinner } from "@ab.uitools/ui-library/components/Spinner";
import type { ReactNode } from "react";

interface Props {
  isError?: boolean;
  isFetching?: boolean;
  isEmpty?: boolean;
  children?: ReactNode;
  error?: IError;
  refetch?: () => void;
  emptyTitle?: string;
  emptySubtitle?: string;
}

export const ListContentWrapper = ({
  isError,
  isEmpty,
  isFetching,
  children,
  error,
  refetch,
  emptyTitle,
  emptySubtitle,
}: Props) => {
  return (
    <>
      {isEmpty && !isError && !isFetching ? (
        <div className="full-width flexbox align-items--center pt-32 pb-32 empty-content-wrapper">
          <EmptyOrErrorContent
            title={emptyTitle}
            subtitle={emptySubtitle}
            isShowButton={false}
          />
        </div>
      ) : isError && !isFetching ? (
        <div className="full-width flexbox align-items--center pt-32 pb-32 empty-content-wrapper">
          <EmptyOrErrorContent
            isError={true}
            title={(error as IError)?.data?.warnings?.[0]}
            action={refetch}
          />
        </div>
      ) : (
        isFetching ? (
          <div
            className="full-width flexbox justify-content--center align-items--center loader-wrapper">
            <Spinner isFullScreen={false} size="small"/>
          </div>
        ) : children
      )}
    </>
  );
};
